let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings',
  'HomeService',
  '$uibModal',
  '$timeout',
  'CartService'
];

class SlidersController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings, HomeService, $uibModal, $timeout, CartService) {
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.HomeService  = HomeService;
    this.CartService = CartService;
    this.$timeout = $timeout;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }

  $onInit(){

  }
}

SlidersController.$inject = inject;

export default SlidersController;




/** WEBPACK FOOTER **
 ** ./www/components/home/sliders/sliders.controller.js
 **/